module.exports = __webpack_public_path__ + "static/img/education3.3fe9aee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/education3.jpg
// module id = 3MBQ
// module chunks = 1